var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sr_trace_track"},[_c('SrTrace',{ref:"sr_trace_track",attrs:{"trackData":_vm.trackData,"defaultProps":_vm.defaultProps,"imgUrl":_vm.imgUrl,"theme":_vm.theme}}),_vm._v(" "),_c('div',{staticClass:"traceTrackBtn",on:{"click":_vm.open}},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fcc4a602","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/SrTraceTrack/index.vue
// module id = 187
// module chunks = 0